// Theme: solstice-aurum
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'solstice-aurum',
  name: 'SOLSTICE AURUM',
  tagline: 'SOLSTICE AURUM',
  description: 'Estrutura Winter Solstice com paleta ouro solar.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#1A1510', '#2A2018', '#D4AC57', '#FFF1CB'],
  familyId: 'winter-solstice',
  variantName: 'AURUM',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-solstice-aurum'
  },
  colorVars: {
    '--accent': '#D4AC57',
    '--accent-foreground': '#1A1510',
    '--background': '#1A1510',
    '--border': '#6A5020',
    '--card': '#2A2018',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF1CB',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1510',
    '--foreground': '#FFF1CB',
    '--hold-fill': '#D4AC57',
    '--input': '#6A5020',
    '--modal-bg': '#1A1510',
    '--modal-border': '#6A5020',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#6A5020',
    '--muted-foreground': '#FFF1CB',
    '--nav-active': '#D4AC57',
    '--nav-bg': '#2A2018',
    '--popover': '#2A2018',
    '--popover-foreground': '#FFF1CB',
    '--primary': '#D4AC57',
    '--primary-foreground': '#1A1510',
    '--ring': '#D4AC57',
    '--secondary': '#6A5020',
    '--secondary-foreground': '#FFF1CB',
    '--streak': '#D4AC57',
    '--success': '#22c55e',
    '--success-foreground': '#1A1510',
    '--xp': '#D4AC57',
    '--xp-bg': '#2A2018'
  },
  resolvedVars: {
    '--accent': '#D4AC57',
    '--accent-foreground': '#1A1510',
    '--accent-foreground-hsl': '30 24% 8%',
    '--accent-foreground-oklch': 'from #1A1510 l c h',
    '--accent-hsl': '41 59% 59%',
    '--accent-oklch': 'from #D4AC57 l c h',
    '--background': '#1A1510',
    '--background-hsl': '30 24% 8%',
    '--background-oklch': 'from #1A1510 l c h',
    '--border': '#6A5020',
    '--border-hsl': '39 54% 27%',
    '--border-oklch': 'from #6A5020 l c h',
    '--border-w': '1px',
    '--card': '#2A2018',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF1CB',
    '--card-foreground-hsl': '44 100% 90%',
    '--card-foreground-oklch': 'from #FFF1CB l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '27 27% 13%',
    '--card-oklch': 'from #2A2018 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1510',
    '--destructive-foreground-hsl': '30 24% 8%',
    '--destructive-foreground-oklch': 'from #1A1510 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFF1CB',
    '--foreground-hsl': '44 100% 90%',
    '--foreground-oklch': 'from #FFF1CB l c h',
    '--hold-fill': '#D4AC57',
    '--hold-fill-hsl': '41 59% 59%',
    '--hold-fill-oklch': 'from #D4AC57 l c h',
    '--input': '#6A5020',
    '--input-hsl': '39 54% 27%',
    '--input-oklch': 'from #6A5020 l c h',
    '--modal-bg': '#1A1510',
    '--modal-bg-hsl': '30 24% 8%',
    '--modal-bg-oklch': 'from #1A1510 l c h',
    '--modal-border': '#6A5020',
    '--modal-border-hsl': '39 54% 27%',
    '--modal-border-oklch': 'from #6A5020 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#6A5020',
    '--muted-foreground': '#FFF1CB',
    '--muted-foreground-hsl': '44 100% 90%',
    '--muted-foreground-oklch': 'from #FFF1CB l c h',
    '--muted-hsl': '39 54% 27%',
    '--muted-oklch': 'from #6A5020 l c h',
    '--nav-active': '#D4AC57',
    '--nav-active-hsl': '41 59% 59%',
    '--nav-active-oklch': 'from #D4AC57 l c h',
    '--nav-bg': '#2A2018',
    '--nav-bg-hsl': '27 27% 13%',
    '--nav-bg-oklch': 'from #2A2018 l c h',
    '--popover': '#2A2018',
    '--popover-foreground': '#FFF1CB',
    '--popover-foreground-hsl': '44 100% 90%',
    '--popover-foreground-oklch': 'from #FFF1CB l c h',
    '--popover-hsl': '27 27% 13%',
    '--popover-oklch': 'from #2A2018 l c h',
    '--primary': '#D4AC57',
    '--primary-foreground': '#1A1510',
    '--primary-foreground-hsl': '30 24% 8%',
    '--primary-foreground-oklch': 'from #1A1510 l c h',
    '--primary-hsl': '41 59% 59%',
    '--primary-oklch': 'from #D4AC57 l c h',
    '--radius': '12px',
    '--ring': '#D4AC57',
    '--ring-hsl': '41 59% 59%',
    '--ring-oklch': 'from #D4AC57 l c h',
    '--secondary': '#6A5020',
    '--secondary-foreground': '#FFF1CB',
    '--secondary-foreground-hsl': '44 100% 90%',
    '--secondary-foreground-oklch': 'from #FFF1CB l c h',
    '--secondary-hsl': '39 54% 27%',
    '--secondary-oklch': 'from #6A5020 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#D4AC57',
    '--streak-hsl': '41 59% 59%',
    '--streak-oklch': 'from #D4AC57 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A1510',
    '--success-foreground-hsl': '30 24% 8%',
    '--success-foreground-oklch': 'from #1A1510 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(41 59% 59% / 0.15)',
    '--xp': '#D4AC57',
    '--xp-bg': '#2A2018',
    '--xp-bg-hsl': '27 27% 13%',
    '--xp-bg-oklch': 'from #2A2018 l c h',
    '--xp-hsl': '41 59% 59%',
    '--xp-oklch': 'from #D4AC57 l c h'
  }
}
